module.exports = __webpack_public_path__ + "static/02-9b9241878a1db97c49244bcfe07ceaa0.jpg";